import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";


import '../src/pages/genaral.css'
import Splash from './pages/splashS';
import Home from './pages/home';
import StoryIntro from './pages/story';
import Mainmenu from './pages/MainMenu';
import Shop from './pages/shop';
import LevelSelect from './pages/Levelselect';
import Level1 from './pages/Level1';
import Level2 from './pages/Level2';
import Level3 from './pages/Level3';
import Level4 from './pages/Level4';
import Level5 from './pages/Level5';
import Level6 from './pages/Level6';



const Routess = () => {
  return (

    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Splash />} />
        <Route path="/home" element={<Home />} />
        <Route path="/story" element={<StoryIntro />} />
        <Route path="/mainmenu" element={<Mainmenu />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/levels" element={<LevelSelect />} />
        <Route path="/level1" element={<Level1 />} />
        <Route path="/level2" element={<Level2 />} />
        <Route path="/level3" element={<Level3 />} />
        <Route path="/level4" element={<Level4 />} />
        <Route path="/level5" element={<Level5 />} />
        <Route path="/level6" element={<Level6 />} />
     
      </Routes>
    </BrowserRouter>
  );
};

export default Routess;